import { ArrowLeft } from "@bale/ui";
import React, { useEffect } from "react";
import styles from "./Breadcrumb.module.scss";
import classNames from "classnames";

interface Props {
  seperator?: JSX.Element;
  data: {
    label: string;
    onClick: () => void;
    isActive?: boolean;
  }[];
}

const Breadcrumb: React.FC<React.PropsWithChildren<Props>> = (props) => {
  let Seperator = <ArrowLeft size={24} />;
  useEffect(() => {
    Seperator = props.seperator ?? <ArrowLeft size={24} />;
  }, [props.seperator]);
  return (
    <div className={styles.Container}>
      {props.data.map((item) => (
        <div className={styles.LabelWrapper} key={item.label}>
          <p
            className={classNames(styles.Label, {
              [styles.Active]: item.isActive,
            })}
            onClick={item.isActive ? undefined : item.onClick}
          >
            {item.label}
          </p>
          <div className={styles.Seperator}>{Seperator}</div>
        </div>
      ))}
    </div>
  );
};

export default Breadcrumb;
